import { loginModule } from "../login-module";


function thermsController($scope, thermOfUseAdherenceService, $sce) {
    var ctrl = this;

    ctrl.$onInit = async function () {
        const therm = await thermOfUseAdherenceService.getThermOfUse("management")
        ctrl.thermOfUse = $sce.trustAsHtml(therm)
    }

    this.start = async function () {

    }

}

loginModule.component('therms', {
    template: require('./therms.component.html'),
    controller: ['$scope', 'thermOfUseAdherenceService', '$sce', thermsController],

});